import { render, staticRenderFns } from "./powered-by.vue?vue&type=template&id=2883a13a"
import script from "./powered-by.vue?vue&type=script&lang=js"
export * from "./powered-by.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports